import { commonUtils } from './common_utils';

const nativeShare = {
    copyLinkToClipboard(shareData) {
        let shareAdUrl = $(shareData).data('url');
        if (navigator.clipboard) {
            navigator.clipboard.writeText(shareAdUrl);
        } else {
            let $temp = $('<input>');
            $('body').append($temp);
            $temp.val(shareAdUrl).select();
            document.execCommand('copy');
            $temp.remove();
        }
        commonUtils.dataLayer.shareButtonDataLayerEvent('Copy link');
        $(shareData).hide();
        $(shareData).next().removeClass('none-imp');
        setTimeout(function () {
            $(shareData).show();
            $(shareData).next().addClass('none-imp');
        }, 5000);
    },

    shareAd(shareData) {
        let shareAdUrl = $(shareData).data('url');
        const shareLinkData = {
            url: shareAdUrl,
        };
        if (navigator.share) {
            $('.page-features__share_drop-down').addClass('none-imp');
            navigator.share(shareLinkData);
            commonUtils.dataLayer.shareButtonDataLayerEvent('Native Share');
        } else if ($(shareData).hasClass('articleShare')) {
            nativeShare.copyLinkToClipboard(shareData);
        }
    },

    init() {
        let $body = $('body');

        // For copy link to clipboard
        $body.on('click', '.copyLinkToClipboard', function () {
            nativeShare.copyLinkToClipboard($(this));
        });

        // For native share
        $body.on('click', '.nativeShare', function () {
            nativeShare.shareAd($(this));
        });
    },
};

$(function () {
    nativeShare.init();
});
